import { ColumnDef } from '@tanstack/react-table'
import { Badge } from '@/common/ui/badge'
import { GetBlacklistResponse } from '../../type'
import { BlacklistEditModal } from './CellAction/components/BlacklistEditModal'
import { BlacklistDeleteButton } from './CellAction/components/BlacklistDeleteButton'
import { BlacklistViewReasonsDialog } from './CellAction/components/BlacklistViewReasonsDialog'

export const createBlacklistTableColumns = (): ColumnDef<
	GetBlacklistResponse['data'][number]
>[] => [
	{
		accessorKey: 'accountNumber',
		header: 'เลขบัญชี',
		cell: ({ row }) => {
			const accountNumber = row.getValue('accountNumber') as string
			return <span className="font-mono">{accountNumber}</span>
		},
	},
	{
		accessorKey: 'accountName',
		header: 'ชื่อบัญชี',
		cell: ({ row }) => {
			const accountName = row.getValue('accountName') as string
			return <span>{accountName}</span>
		},
	},
	{
		accessorKey: 'bankProviderName',
		header: 'ธนาคาร',
		cell: ({ row }) => {
			const bankProviderName = row.getValue('bankProviderName') as string
			return (
				<Badge variant="outline" className="font-medium">
					{bankProviderName}
				</Badge>
			)
		},
	},

	{
		accessorKey: 'reasons',
		header: 'เหตุผล',
		cell: ({ row }) => {
			const item = row.original
			return <BlacklistViewReasonsDialog item={item} />
		},
	},
	{
		accessorKey: 'totalReport',
		header: 'จำนวนการรายงาน',
		cell: ({ row }) => {
			const totalReport = row.getValue('totalReport') as number
			return <span>{totalReport}</span>
		},
	},
	{
		accessorKey: 'createdAt',
		header: 'วันที่สร้าง',
		cell: ({ row }) => {
			const createdAt = row.getValue('createdAt') as string
			return new Date(createdAt).toLocaleDateString('th-TH', {
				year: 'numeric',
				month: 'short',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
			})
		},
	},
	{
		id: 'actions',
		header: 'จัดการ',
		cell: ({ row }) => {
			const item = row.original
			return (
				<div className="flex items-center gap-2">
					<BlacklistEditModal item={item} />
					<BlacklistDeleteButton
						id={item.id}
						accountNumber={item.accountNumber}
						createdBy={item.createdBy}
					/>
				</div>
			)
		},
	},
]
